"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiGroup = _interopRequireDefault(require("./ApiGroup"));
class Tokens extends _ApiGroup.default {
  /**
   * List of past token transfers
   */
  transfers(contractId, address) {
    let filter = {};
    if (address) {
      filter.address = address;
    }
    return this.request({
      url: `/tokens/${contractId}/transfers`,
      params: filter
    }).then(response => response.data.data);
  }
  name(contractId) {
    return this.request({
      url: `/contracts/${contractId}/call/name`
    }).then(response => response.data.data);
  }
  symbol(contractId) {
    return this.request({
      url: `/contracts/${contractId}/call/symbol`
    }).then(response => response.data.data);
  }
  decimals(contractId) {
    return this.request({
      url: `/contracts/${contractId}/call/decimals`
    }).then(response => response.data.data);
  }
  info(network, address) {
    return this.request({
      url: `/tokens/${network}/${address}`
    }).then(response => response.data.data);
  }
}
var _default = exports.default = Tokens;
//# sourceMappingURL=Tokens.js.map